/**
 * Format practice area label with taxonomy ID if available
 * @param area - The practice area object (can be PracticeArea or any object with name and taxonomyId)
 * @returns Formatted label string in format "[taxonomyId] name" or just "name"
 */
export const formatPracticeAreaLabel = (area: { name: string; taxonomyId?: number }): string => {
    if (area.taxonomyId) {
        return `[${area.taxonomyId}] ${area.name}`;
    }
    return area.name;
};
